import React, { useState } from 'react'
import { Button, Space, Tooltip } from 'antd'
import {
  EditOutlined,
  CheckOutlined,
  InfoCircleOutlined
} from '@ant-design/icons'
import { useScreenSize } from '../../../../CustomHooks/screenSize.hooks'

type EditableProps<T> = T & {
  mode?: string
  value: any
  onChange: (value: any) => void
  onSubmit: (value: any) => void
  disabled: boolean
  editable: boolean
  hasHelp?: boolean
  helpOptions: { label: string; description: string }[]
}

const withEditable = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  return ({
    mode,
    value,
    onChange,
    onSubmit,
    disabled,
    editable,
    hasHelp,
    helpOptions,
    ...props
  }: EditableProps<P>) => {
    const screenSize = useScreenSize()
    const [editMode, setEditMode] = useState(false)
    const [localValue, setLocalValue] = useState(value)

    const handleEdit = () => setEditMode(true)
    const handleSave = () => {
      onSubmit(localValue)
      setEditMode(false)
    }

    return (
      <Space>
        <WrappedComponent
          {...(props as P)}
          mode={mode}
          value={localValue}
          onChange={(e: any) => {
            const newValue = e?.target ? e.target.value : e // For Input vs Select
            setLocalValue(newValue)
            onChange(newValue)
          }}
          style={{ width: '100%', maxWidth: '400px', minWidth: 'min(100%, 200px)' }}
          disabled={disabled || !editMode}
          {...props}
        />
        {editMode ? (
          <Button
            type='primary'
            icon={<CheckOutlined />}
            onClick={handleSave}
          />
        ) : (
          editable && <Button icon={<EditOutlined />} onClick={handleEdit} />
        )}
        {hasHelp && (
          <Tooltip
            title={helpOptions?.map((option, index) => {
              return (
                <div key={index}>
                  <h3
                    style={{
                      background: '#1777ff',
                      padding: '5px',
                      borderRadius: '4px'
                    }}
                  >
                    {option?.label}
                  </h3>
                  <h5
                    style={{
                      color: 'white',
                      padding: '4px',
                      borderRadius: '5px'
                    }}
                  >
                    {option?.description}
                  </h5>
                </div>
              )
            })}
            color={'#001628'}
          >
            <InfoCircleOutlined />
          </Tooltip>
        )}
      </Space>
    )
  }
}

export default withEditable
